import UserControllerBase from '../base'
import type {
  NConfirmEmailValidationCode,
  NConfirmPhoneNumberValidationCode,
  NLogin,
  NRequestEmailValidationCode,
  NRequestPhoneNumberValidationCode,
  NTwoFactorAuthentication,
  NRenewToken,
} from './types'
import type { TResponseBase } from '~/services/MSAPI/types'

export default class UserControllerAuthentication extends UserControllerBase {
  static readonly controllerPath = 'authentication'
  private readonly serviceUrl: string

  constructor() {
    super(UserControllerAuthentication.controllerPath)
    this.serviceUrl = this.getFullServiceUrl()
  }

  async login(body: NLogin.IBody): TResponseBase<NLogin.IResponseData> {
    return await useFetchInstance(`${this.serviceUrl}/login`, {
      method: 'POST',
      body,
    })
  }

  async getMFA(
    userId: string,
  ): TResponseBase<NTwoFactorAuthentication.IReponseMFA> {
    return await useFetchInstance(`${this.serviceUrl}/mfa`, {
      method: 'GET',
      params: { userId },
    })
  }

  async upateMFA(
    body: NTwoFactorAuthentication.IUpdateMFARequest,
  ): TResponseBase<boolean> {
    return await useFetchInstance(`${this.serviceUrl}/mfa/sms`, {
      method: 'POST',
      body,
    })
  }

  async validateMFA(
    body: NTwoFactorAuthentication.IUpdateMFAValidate,
  ): TResponseBase<boolean> {
    return await useFetchInstance(`${this.serviceUrl}/mfa/sms/validate`, {
      method: 'POST',
      body,
    })
  }

  async resendMFA(
    body: NTwoFactorAuthentication.IUpdateMFA,
  ): TResponseBase<boolean> {
    return await useFetchInstance(`${this.serviceUrl}/mfa/sms/resend`, {
      method: 'POST',
      body,
    })
  }

  async loginSMSMFA(
    body: NTwoFactorAuthentication.ILoginSMSMFARequest,
  ): TResponseBase<NLogin.IResponseData> {
    return await useFetchInstance(`${this.serviceUrl}/mfa/login/sms`, {
      method: 'POST',
      body,
    })
  }

  async requestEmailValidationCode(
    body: NRequestEmailValidationCode.IBody,
  ): TResponseBase<boolean> {
    return await useFetchInstance(
      `${this.serviceUrl}/request-email-validation-code`,
      {
        method: 'POST',
        body,
      },
    )
  }

  async requestPhoneNumberValidationCode(
    body: NRequestPhoneNumberValidationCode.IBody,
  ): TResponseBase<boolean> {
    return await useFetchInstance(
      `${this.serviceUrl}/request-phoneNumber-validation-code`,
      {
        method: 'POST',
        body,
      },
    )
  }

  async confirmEmailValidationCode(
    body: NConfirmEmailValidationCode.IBody,
  ): TResponseBase<boolean> {
    return await useFetchInstance(`${this.serviceUrl}/confirm-email`, {
      method: 'POST',
      body,
    })
  }

  async confirmPhoneNumberValidationCode(
    body: NConfirmPhoneNumberValidationCode.IBody,
  ): TResponseBase<boolean> {
    return await useFetchInstance(`${this.serviceUrl}/confirm-phonenumber`, {
      method: 'POST',
      body,
    })
  }

  async renewToken(
    refreshToken: string,
  ): TResponseBase<NRenewToken.IRResponseData> {
    return await useFetchInstance(`${this.serviceUrl}/token/renew`, {
      method: 'POST',
      body: { refreshToken },
    })
  }
}
